import { restApi } from '../services/api';

const MAX_TIME_TO_WAIT = 4000;
const GOOGLE_PING_URL = 'https://www.gstatic.com/generate_204';
export const URL_TO_VALIDATE_IF_USER_IS_ONLINE = '/monitoring/ping';

const fallbackValidateWithGoogle = async () => {
  try {
    const controller = new AbortController();
    const { signal } = controller;
    const timeout = setTimeout(() => {
      controller.abort();
    }, MAX_TIME_TO_WAIT);

    const googleRes = await fetch(GOOGLE_PING_URL, { mode: 'no-cors', signal });

    clearTimeout(timeout);

    return googleRes.type === 'opaque';
  } catch (e) {
    const isTimeoutError = e instanceof DOMException && e.name === 'AbortError';

    return isTimeoutError ? true : false;
  }
};

export const validateIfUserIsOnline = async () => {
  try {
    const apiResult = await restApi.get(URL_TO_VALIDATE_IF_USER_IS_ONLINE, undefined, {
      timeout: MAX_TIME_TO_WAIT,
    });

    const apiPingSucceeded = apiResult.problem !== 'NETWORK_ERROR';

    if (!apiPingSucceeded) {
      const googlePingSucceeded = await fallbackValidateWithGoogle();
      return googlePingSucceeded;
    }

    return apiPingSucceeded;
  } catch (_) {
    return true;
  }
};
